import { makeCloudFunction } from "../makeCloudFunction";
import { ListActivityRequest, ListActivityResponse } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";

export const listActivity = makeCloudFunction<
  ListActivityRequest,
  ListActivityResponse
>("activity", "listActivity");
export const useListActivity = makeUseCloudFunction(listActivity);
